import { IdiomaService } from './../providers/idioma/idioma.service';
import { Component, EventEmitter, Input, Output, ViewChild, Inject, forwardRef, OnDestroy, AfterViewInit, OnChanges } from '@angular/core';
import { EntityManagerProvider } from '../providers/entity-manager-provider/entity-manager-provider';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { element } from 'protractor';
import { SeccionFormulario, SeccionIdiomaFormulario } from '../domain/SeccionFormulario';
import { VIEWPORT_RULER_PROVIDER_FACTORY } from '@angular/cdk/scrolling';
import { ColorPickerModule, SelectItem } from 'primeng/primeng';
import { Constantes } from '../domain/constantes';
import { Idioma } from '../domain/Idioma';
import {TranslatePipe, TranslateService, LangChangeEvent} from 'ng2-translate';
import { Permisos, PermisosService } from '../providers/authentication/permisos.service';
import { AppComponent } from '../app.component';
import { IdiomaCalendario } from '../domain/IdiomaCalendatio';
import { forEach } from '@angular/router/src/utils/collection';
import * as allSettled from 'promise-all-settled';


@Component({
  selector: 'app-formulario-seccion',
  templateUrl: './FormularioSeccion.component.html',
  styleUrls: ['./FormularioSeccion.component.scss'],
})

export class FormularioSeccionComponent implements OnDestroy, AfterViewInit, OnChanges{
	[x: string]: any;

  @Input() seccionSeleccionada: SeccionFormulario = new SeccionFormulario();
  @Input() edicion: boolean;
  @Input() confirmacionVisible: boolean;
  @Input() apareceBoton: boolean = false;
  @Input() msgs: any[];
  @Input() visible: boolean = true;
  @Input() colorSeleccionado: string = 'rgba(0,0,0,0.4)';
  @Input() opcionesSelectorTipologia: any[]  = [];


  @Output() onEyedropperSelected: EventEmitter <any> = new EventEmitter();
  @Output() onElementoGuardado: EventEmitter <any> = new EventEmitter();
  @Output() onElementoError: EventEmitter <any> = new EventEmitter();
  @Output() onElementoEliminado: EventEmitter <any> = new EventEmitter();
  @Output() onFormularioValidation: EventEmitter <boolean> = new EventEmitter();

	public isValid = true;
	public color;

	public operacion;

	private isEyedropSelected = false;
	private classEyedrop = [];

	/* IDIOMA */
	idiomas;
	idiomaSeleccionado: Idioma;
	idiomaDefecto: Idioma;
	idiomaCalendario: IdiomaCalendario;

	Mapa_plano_seccion_formulario = 0;

	spinner: HTMLElement;
	public permiteContenidos: boolean = false;

	//Tipologías
	public tipologias_seleccionadas: any[] = [];
	public muestraTipologias: boolean = false;



	constructor(
		private appComponent: AppComponent,
		private entityManagerProvider: EntityManagerProvider,
		public authService: AuthenticationService,
		public idiomaService: IdiomaService,
		private translate: TranslateService,
		private permisosService: PermisosService
	){
		const that = this;
		// Inicializamos Spinner
		this.spinner = document.getElementsByClassName('spinner-container')[0] as HTMLElement;
		this.spinner.style.display = 'none';


		this.idiomaCalendario = new IdiomaCalendario();
		this.idiomaCalendario.firstDayOfWeek = 1;
		this.idiomaCalendario.dayNames = this.translate.instant('Calendario.dayNames');
		this.idiomaCalendario.dayNamesShort = this.translate.instant('Calendario.dayNamesShort');
		this.idiomaCalendario.dayNamesMin = this.translate.instant('Calendario.dayNamesMin');
		this.idiomaCalendario.monthNames = this.translate.instant('Calendario.monthNames');
		this.idiomaCalendario.monthNamesShort = this.translate.instant('Calendario.monthNamesShort');
		this.idiomaCalendario.today = this.translate.instant('Calendario.today');
		this.idiomaCalendario.clear = this.translate.instant('Calendario.clear');


		this.entityManagerProvider.getIDIOMA()
		.then(function (idiomasENTIDAD: any) {

			that.idiomas = [];
			idiomasENTIDAD.forEach(idioma => {
				if(idioma.Visible === true){
				that.idiomas.push(new Idioma(idioma));
				}
			});

			that.idiomaDefecto = that.idiomaService.getIdiomaDefecto(that.idiomas);
			that.idiomaSeleccionado = that.idiomaDefecto;

			return that.comprobarPermisos();
		});
		/*if(this.seccionSeleccionada.FechaBaja !== null){
			this.apareceBoton = true;
		}*/
	}

	ngAfterViewInit(): void {
		// Nada

	}

	ngOnDestroy(): void {
		this.entityManagerProvider.RejectChanges();

	}
	comprobacionTipologia(){
		//this.muestraTipologias = false;
		setTimeout(() => {
			if(this.seccionSeleccionada.TIPOLOGIAS_SECCION[0]){
			
				if(this.seccionSeleccionada.TIPOLOGIAS_SECCION[0].Activa === false) {
					this.seccionSeleccionada.TIPOLOGIAS_SECCION[0] = null;
					this.opcionesSelectorTipologia = this.opcionesSelectorTipologia.filter(o => o.Activa === true);
					this.muestraTipologias = true;
				}
	
				
				
			}else{
				this.opcionesSelectorTipologia = this.opcionesSelectorTipologia.filter(o => o.Activa === true);
				this.muestraTipologias = true;
			}
		}, 250);
	}

	ngOnChanges(change){

		if ( this.isEyedropSelected ){
			this.actualizaColor();
		}



		// si el cambio ha sido en el color no actualizamos el idioma
		if (change.colorSeleccionado === undefined) {
			if (this.idiomaDefecto){
				this.setIdioma(this.idiomaDefecto);
			}
		}
		if (change.seccionSeleccionada && change.seccionSeleccionada.previousValue && change.seccionSeleccionada.previousValue.FechaBaja !== null){
			this.apareceBoton = true;
		}
		else{
			this.permiteContenidos = false;
			this.apareceBoton = false;
		}
		console.log(this.seccionSeleccionada)
		this.muestraTipologias = false;
		setTimeout(() => {
			if(this.seccionSeleccionada.TIPOLOGIAS_SECCION[0]){
			
				if(this.seccionSeleccionada.TIPOLOGIAS_SECCION[0].Activa === false && this.opcionesSelectorTipologia.length > 0) {
					
					let existe = this.opcionesSelectorTipologia.find(o => o === this.seccionSeleccionada.TIPOLOGIAS_SECCION[0]);
					if(!existe){
						this.opcionesSelectorTipologia.push(this.seccionSeleccionada.TIPOLOGIAS_SECCION[0]);
					}
					this.muestraTipologias = true;
				}else if(this.seccionSeleccionada.TIPOLOGIAS_SECCION[0].Activa === true && this.opcionesSelectorTipologia.length > 0){
					
					this.opcionesSelectorTipologia = this.opcionesSelectorTipologia.filter(o => o.Activa === true);
					this.muestraTipologias = true;
				}else{
					this.muestraTipologias = false;
				}
	
				console.log(this.opcionesSelectorTipologia);
				
			}else{
				this.muestraTipologias = true;
			}
		}, 250);

	}

	comprobarPermisos() {
		this.Mapa_plano_seccion_formulario = 0;
		const userId = this.authService.getIdUsuario();
		const that = this;
		return this.entityManagerProvider.getFUNCIONALIDADESbyUSUARIO(userId)
		.then(function(funcionalidades){

			if (funcionalidades) {
				funcionalidades.forEach(funcion => {
					if (funcion.FUNCIONALIDAD) {
						if (funcion.FUNCIONALIDAD.Nombre === Permisos.Constante_Mapa_plano_seccion_formulario) {
							that.Mapa_plano_seccion_formulario = funcion.Tipo;
						}
					}
				});
			}

		});
	}

/* ************************************************************************** */
/*                            COMUN FORMULARIO                                */
/* ************************************************************************** */

	inputChanged(value) {
		if(value === 'FechaBaja'){
			if(this.seccionSeleccionada.FechaBaja !== null){
				console.log("Ha cambiado la fecha");
				this.apareceBoton = true;
			}
			else{
				this.apareceBoton = false;
				this.permiteContenidos = false;
			}
		}
		//  Cojemos la traduccion del espacio al idioma seleccionado
		const seccionIdioma = this.seccionSeleccionada.Idiomas.get(this.idiomaSeleccionado.ENTIDAD.Codigo);

		// Guardamos los posibles cambios del idioma
		seccionIdioma.Nombre = this.seccionSeleccionada.Nombre;
		seccionIdioma.Descripcion = this.seccionSeleccionada.Descripcion;
		this.seccionSeleccionada.Idiomas.set(this.idiomaSeleccionado.ENTIDAD.Codigo, seccionIdioma);
	}

	public esEdicion(): boolean {
		return this.seccionSeleccionada && (this.seccionSeleccionada.Id ? true : false);
		// return this.edicion;
	}

	public validar(): boolean {
		console.warn('Implementar: validar');
		if (this.seccionSeleccionada.Nombre === '' || this.seccionSeleccionada.Nombre === undefined) {
			this.isValid = false;
		}
		else {
			this.isValid = true;
		}

		this.onFormularioValidation.emit(this.isValid);

		return this.isValid;
	}

	public guardar(): any {
		if (this.validar()) {
			this.spinner.style.display = 'inherit';
			if (!this.esEdicion()) {
			this.guardarNuevo();
			}
			else{
			this.guardarEdicion();
			}
		} else {
			this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
			this.confirmacionVisible = false;
			//this.apareceBoton = false;
			console.log('Formulario no completo!');
		}
	}
	public guardarConContenidos(): any {
		if (this.validar()) {
			this.spinner.style.display = 'inherit';
			if (!this.esEdicion()) {
			this.guardarNuevo();
			}
			else{
			this.guardarEdicionConContenidos();
			}
		} else {
			this.appComponent.showError(this.translate.instant('MensajesConfirmacion.MENSAJE_FORMULARIO_NO_VALIDO'));
			this.confirmacionVisible = false;
			//this.apareceBoton = false;
			console.log('Formulario no completo!');
		}
	}
	public guardarNuevo () {
	}
	protected guardarEdicionConContenidos(){

		const that = this;

		return this.guardarMultiIdioma()
		.then(function(msg) {

			const seccionIdioma = that.seccionSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.seccionSeleccionada.Nombre = seccionIdioma.Nombre ? seccionIdioma.Nombre : '';
			that.seccionSeleccionada.Descripcion = seccionIdioma.Descripcion ? seccionIdioma.Descripcion : '';

			that.seccionSeleccionada.ENTIDAD.Nombre = that.seccionSeleccionada.Nombre;
			that.seccionSeleccionada.ENTIDAD.Descripcion = that.seccionSeleccionada.Descripcion;

			that.seccionSeleccionada.ENTIDAD.FechaAlta = that.seccionSeleccionada.FechaAlta;
			that.seccionSeleccionada.ENTIDAD.FechaBaja = that.seccionSeleccionada.FechaBaja;
			//contenidos
			if(that.seccionSeleccionada.numeroCONTENIDOS !== 0){
				that.seccionSeleccionada.ENTIDAD.CONTENIDOS.forEach(c =>{
					if(c.CONTENIDO.FechaBaja === null){
						c.CONTENIDO.FechaBaja = that.seccionSeleccionada.FechaBaja;
					}
					let fechaauxDayRuta = new Date(that.seccionSeleccionada.FechaBaja).getDate();
					let fechaauxDayContenido = c.CONTENIDO.FechaBaja.getDate();

					let fechaauxMonthRuta = new Date(that.seccionSeleccionada.FechaBaja).getMonth();
					let fechaauxMonthContenido = c.CONTENIDO.FechaBaja.getMonth();

					let fechaauxYearRuta = new Date(that.seccionSeleccionada.FechaBaja).getFullYear();
					let fechaauxyearContenido = c.CONTENIDO.FechaBaja.getFullYear();

					if( fechaauxyearContenido > fechaauxYearRuta){
						c.CONTENIDO.FechaBaja = that.seccionSeleccionada.FechaBaja;
					}
					else if(fechaauxyearContenido === fechaauxYearRuta){
						if(fechaauxMonthContenido > fechaauxMonthRuta){
							c.CONTENIDO.FechaBaja = that.seccionSeleccionada.FechaBaja;
						}
						else if(fechaauxMonthContenido === fechaauxMonthRuta && fechaauxDayContenido > fechaauxDayRuta){
							c.CONTENIDO.FechaBaja = that.seccionSeleccionada.FechaBaja;
						}

					}
				});
			}

			that.seccionSeleccionada.ENTIDAD.CoordenadasPoligono = JSON.stringify(that.seccionSeleccionada.SECCION_PLANO.getCoordenadasPoligono());
			that.seccionSeleccionada.ENTIDAD.Color = 'rgba(' + that.seccionSeleccionada.Color.r + ',' + that.seccionSeleccionada.Color.g + ','  + that.seccionSeleccionada.Color.b + ',' + that.seccionSeleccionada.Color.a + ')';

			const alfa = that.seccionSeleccionada.Color.a;
			const arrayColorHover = Constantes.seccionHoverFill.split('rgba(')[1].split(')')[0].split(',');
			const objetoColorHover  =  {r: arrayColorHover[0], g: arrayColorHover[1], b: arrayColorHover[2], a: arrayColorHover[3]};
			// Creamos el color hover de la seccion con el alfa del color de la seccion en reposo
			const seccionHoverColor = 'rgba(' + objetoColorHover.r + ',' + objetoColorHover.g + ','  + objetoColorHover.b + ',' + alfa + ')';
			that.seccionSeleccionada.SECCION_PLANO.setFill(that.seccionSeleccionada.ENTIDAD.Color);	// Reposo
			that.seccionSeleccionada.SECCION_PLANO.setHoverFill(seccionHoverColor);					// Hover
			that.seccionSeleccionada.SECCION_PLANO.setNombre(that.seccionSeleccionada.Nombre);

			return that.guardarRelacionesTipologias(that.seccionSeleccionada.ENTIDAD.TIPOLOGIAS, that.seccionSeleccionada.TIPOLOGIAS_SECCION);
			})

			.then(function(msg) {
			return that.entityManagerProvider.saveChanges();
		})
		.then(function(msg) {
			console.log(that.seccionSeleccionada);
			that.onElementoGuardado.emit({ result: true, element: that.seccionSeleccionada });
			that.spinner.style.display = 'none';
			return msg;
		})
		.then(function(data: any) {
			console.log(data)
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.catch(function(err) {
			that.onElementoGuardado.emit({ result: false, element: that.seccionSeleccionada });
			that.spinner.style.display = 'none';
			return err;
		});
	}

	guardarRelacionesTipologias(entidades, tipologias){
		const that = this;
		//const promises = [];
		this.entityManagerProvider.deleteEntityArray(entidades);
		console.log(tipologias)
		
		if(tipologias.length > 0){
			if(tipologias[0] !== null){
				that.entityManagerProvider.newSECCION_has_TIPOLOGIA()
				.then(function(oSeccionHasTipologia){
					if (oSeccionHasTipologia) {
						const relacion = oSeccionHasTipologia;
						const idSeccion = that.seccionSeleccionada.Id;
						const idTipologia = tipologias[0].Id;
						const Seccion = that.seccionSeleccionada;
						const Tipologia = tipologias[0];
						relacion.idSeccion = idSeccion;
						relacion.idTipologia = idTipologia;
						relacion.SECCION = Seccion.ENTIDAD;
						relacion.TIPOLOGIA_SECCION = Tipologia;
					}
		
					return true;
				});
			}
		}

		return true;

		//PARTE PARA CUANDO QUERAMOS ASIGNAR MÁS DE UNA TIPOLOGÍA a la SECCION
		//----------------------------------------------------------------------------
		// tipologias.forEach(tipologia => {
		// 	console.log(tipologia)
		// 	promises.push(that.entityManagerProvider.newSECCION_has_TIPOLOGIA());
		// });
		// return allSettled(promises)
		// .then(function(oSeccionHasTipologia){
		// 	console.log(oSeccionHasTipologia)
		// 	for (let index = 0; index < oSeccionHasTipologia.length; index++) {
		// 		const relacion = oSeccionHasTipologia[index].result;
		// 		const idSeccion = that.seccionSeleccionada.Id;
		// 		const idTipologia = tipologias[index].Id;
		// 		const Seccion = that.seccionSeleccionada;
		// 		const Tipologia = tipologias[index];

		// 		relacion.idSeccion = idSeccion;
		// 		relacion.idTipologia = idTipologia;
		// 		relacion.SECCION = Seccion.ENTIDAD;
		// 		relacion.TIPOLOGIA_SECCION = Tipologia;
		// 	}

		// 	return true;
		// });
	}
	protected guardarEdicion () {
		const that = this;

		return this.guardarMultiIdioma()
		.then(function(msg) {

			const seccionIdioma = that.seccionSeleccionada.Idiomas.get(that.idiomaDefecto.ENTIDAD.Codigo);
			that.seccionSeleccionada.Nombre = seccionIdioma.Nombre ? seccionIdioma.Nombre : '';
			that.seccionSeleccionada.Descripcion = seccionIdioma.Descripcion ? seccionIdioma.Descripcion : '';

			that.seccionSeleccionada.ENTIDAD.Nombre = that.seccionSeleccionada.Nombre;
			that.seccionSeleccionada.ENTIDAD.Descripcion = that.seccionSeleccionada.Descripcion;

			that.seccionSeleccionada.ENTIDAD.FechaAlta = that.seccionSeleccionada.FechaAlta;
			that.seccionSeleccionada.ENTIDAD.FechaBaja = that.seccionSeleccionada.FechaBaja;
			that.seccionSeleccionada.ENTIDAD.CoordenadasPoligono = JSON.stringify(that.seccionSeleccionada.SECCION_PLANO.getCoordenadasPoligono());
			that.seccionSeleccionada.ENTIDAD.Color = 'rgba(' + that.seccionSeleccionada.Color.r + ',' + that.seccionSeleccionada.Color.g + ','  + that.seccionSeleccionada.Color.b + ',' + that.seccionSeleccionada.Color.a + ')';

			const alfa = that.seccionSeleccionada.Color.a;
			const arrayColorHover = Constantes.seccionHoverFill.split('rgba(')[1].split(')')[0].split(',');
			const objetoColorHover  =  {r: arrayColorHover[0], g: arrayColorHover[1], b: arrayColorHover[2], a: arrayColorHover[3]};
			// Creamos el color hover de la seccion con el alfa del color de la seccion en reposo
			const seccionHoverColor = 'rgba(' + objetoColorHover.r + ',' + objetoColorHover.g + ','  + objetoColorHover.b + ',' + alfa + ')';
			that.seccionSeleccionada.SECCION_PLANO.setFill(that.seccionSeleccionada.ENTIDAD.Color);	// Reposo
			that.seccionSeleccionada.SECCION_PLANO.setHoverFill(seccionHoverColor);					// Hover
			that.seccionSeleccionada.SECCION_PLANO.setNombre(that.seccionSeleccionada.Nombre);

			console.log(that.seccionSeleccionada);

			return that.guardarRelacionesTipologias(that.seccionSeleccionada.ENTIDAD.TIPOLOGIAS, that.seccionSeleccionada.TIPOLOGIAS_SECCION);
			})

			.then(function(msg) {
			return that.entityManagerProvider.saveChanges();
		})
		.then(function(msg) {
			that.onElementoGuardado.emit({ result: true, element: that.seccionSeleccionada });
			that.spinner.style.display = 'none';
			return msg;
		})
		.then(function(data: any) {
			// Renovamos el Token
			if(data.httpResponse.status === 200){
				that.authService.relogin();
			}
		})
		.catch(function(err) {
			that.onElementoGuardado.emit({ result: false, element: that.seccionSeleccionada });
			that.spinner.style.display = 'none';
			return err;
		});
	}

	guardarMultiIdioma(){
		const that = this;
		this.entityManagerProvider.deleteEntityArray(this.seccionSeleccionada.ENTIDAD.IDIOMAS);

		return this.entityManagerProvider.newSECCION_IDIOMA(this.seccionSeleccionada.ENTIDAD)
		.then(function(SECCION_IDIOMAs){

			SECCION_IDIOMAs.forEach(SECCION_IDIOMA => {
				const aux = that.seccionSeleccionada.Idiomas.get(SECCION_IDIOMA.IDIOMA.Codigo);
				if (aux) {
					SECCION_IDIOMA.Nombre = aux.Nombre;
					SECCION_IDIOMA.Descripcion = aux.Descripcion;
				}

			});

		});
	}

	public eliminar() {
		const that = this;
		if (this.seccionSeleccionada) {
			that.spinner.style.display = 'inherit';
			return this.entityManagerProvider.deleteSECCION(this.seccionSeleccionada.ENTIDAD)
			.then(function (msg) {
				that.onElementoEliminado.emit({ result: true, element: that.seccionSeleccionada });
				// Renovamos el Token
				that.authService.relogin();

			})
			.catch(function () {
				that.onElementoEliminado.emit({ result: false, element: that.seccionSeleccionada });
			});
		}
		else{
			that.onElementoEliminado.emit({ result: false, element: that.seccionSeleccionada });
			that.authService.relogin();
		}
	}

	/* CONFIRMACION */
	mostrarConfirmacion(operacion){
		if(operacion === 'guardar'){
			if(this.permiteContenidos === true){
				operacion = 'guardarConContenidos';
			}
		}
		this.appComponent.showWarn(operacion);
		this.operacion = operacion;
		this.confirmacionVisible = true;
		/*if(this.seccionSeleccionada.FechaBaja !== null){
			this.apareceBoton = true;
		}*/
	}

	confirmar(){
		this.msgs = [];
		if (this.operacion === 'guardar') {
				this.guardar();

		}
		else if(this.operacion === 'guardarConContenidos'){
			if(this.permiteContenidos === true){
				console.log("Se va a guardar con contenidos");
				this.guardarConContenidos();
			}
		}
		else if (this.operacion === 'eliminar'){
			this.eliminar();
		}
	}

	cancelar(){
		this.msgs = [];
		this.operacion = '';
		this.confirmacionVisible = false;
		/*if(this.seccionSeleccionada.FechaBaja){
			this.apareceBoton = false;
		}*/
	}

	/* IDIOMA */
	onIdiomaChange($event) {
		this.setIdioma($event.value);

	}
	private setIdioma(idioma){

		if (!idioma) {
			return;
		}

		this.idiomaSeleccionado = idioma;

		// Cojemos la traduccion del espacio al idioma seleccionado
		let seccionIdioma = this.seccionSeleccionada.Idiomas.get(idioma.value);

		// Si no existe la creamos
		if (!seccionIdioma) {

			seccionIdioma = new SeccionIdiomaFormulario();

			this.seccionSeleccionada.Idiomas.set(idioma.value, seccionIdioma);

		}

		// Seteamos los valores de espacioFormulario con los valores del idioma seleccionado
		this.seccionSeleccionada.Nombre = seccionIdioma.Nombre;
		this.seccionSeleccionada.Descripcion = seccionIdioma.Descripcion;

		console.log('Cambiar Titulo y descripcion a la del idioma: ' + idioma.value + '(' + idioma.title + ')');
	}


	/* PIPETA */
	seleccionPipeta(){
		this.setEyedropSelected(true);
	}

	public onColorChange($event){
		console.log($event);
	}

	public getColor(){
		return 'rgba(' + this.seccionSeleccionada.Color.r + ',' + this.seccionSeleccionada.Color.g + ',' + this.seccionSeleccionada.Color.b + ',' + this.seccionSeleccionada.Color.a + ')';
	}

	public getAlfa(){

	}

	setPickerState(isOpen){

	}

	public setColor(_color){
		this.colorSeleccionado = _color;
		this.actualizaColor();
	}

	setEyedropSelected(_val){
		this.isEyedropSelected = _val;
		this.onEyedropperSelected.emit(_val);
		if (_val){
			this.classEyedrop = ['eyedropSelected'];
		}else{
			this.classEyedrop = [];
		}
	}

	actualizaColor(){
		const colors = this.colorSeleccionado.match(/\d+/g);
		this.setEyedropSelected(false);
		if ( colors.length < 3 )	{
			return;
		}

		const alfa = colors[3] + (colors[4] !== undefined ? '.' + colors[4] : '' );

		const _nuevoColor = {
			r: colors[0],
			g: colors[1],
			b: colors[2],
			a: alfa
		};

		this.seccionSeleccionada.Color = _nuevoColor;
	}

	onFechaAceptar(dt, calendar, columna, tipo) {
		console.log(calendar);
		const fecha = calendar.value ? calendar.value : new Date();
		if (tipo === 'FechaAlta') {
			this.seccionSeleccionada.FechaAlta = fecha;
		}
		if (tipo === 'FechaBaja') {
			this.seccionSeleccionada.FechaBaja = fecha;
		}
		calendar.overlayVisible=false;
	}
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/formularios/FormularioSeccion.component.ts